import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { Link } from '@/components/links';
import { Image } from './Images';
export function LinkableBanner(t0) {
  const $ = _c(12);
  const {
    src,
    alt,
    width,
    height,
    to,
    testId,
    analyticsParam,
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== alt || $[1] !== height || $[2] !== src || $[3] !== width) {
    t1 = <Image src={src} width={width} height={height} alt={alt} />;
    $[0] = alt;
    $[1] = height;
    $[2] = src;
    $[3] = width;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== analyticsParam || $[6] !== children || $[7] !== className || $[8] !== t1 || $[9] !== testId || $[10] !== to) {
    t2 = <Link className={className} to={to} testId={testId} analyticsParam={analyticsParam}>{t1}{children}</Link>;
    $[5] = analyticsParam;
    $[6] = children;
    $[7] = className;
    $[8] = t1;
    $[9] = testId;
    $[10] = to;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}